"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
require("../../common/style.scss");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _formatVodData2 = require("../../utils/formatVodData");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  CustomerDescription = _require.CustomerDescription;
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos,
  /*
   * 筛选+分页 容器传过来的参数 { }
   * filterTypeList: [0,1,2] 容器过滤之后的列表的索引
   * pageIndex
   * pageSize
   * */
  filterOptions
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString;
  if (Object.keys(data).length > 1) {
    const _ref = data,
      _ref$modTitle = _ref.modTitle,
      modTitle = _ref$modTitle === void 0 ? '' : _ref$modTitle,
      _ref$desc = _ref.desc,
      desc = _ref$desc === void 0 ? '' : _ref$desc,
      _ref$backgroundImage = _ref.backgroundImage,
      backgroundImage = _ref$backgroundImage === void 0 ? '' : _ref$backgroundImage,
      _ref$lightTheme = _ref.lightTheme,
      lightTheme = _ref$lightTheme === void 0 ? false : _ref$lightTheme,
      _ref$configuration = _ref.configuration,
      configuration = _ref$configuration === void 0 ? [] : _ref$configuration,
      bgColor = _ref.color;
    let configurationFormatted = configuration.map((item, index) => {
      let cardStyle = {};
      if ((item === null || item === void 0 ? void 0 : item.cardNumTheme) === 2 && item !== null && item !== void 0 && item.cardStyle2) {
        cardStyle = {
          background: item.cardStyle2,
          border: 'none'
        };
      } else if ((item === null || item === void 0 ? void 0 : item.cardNumTheme) === 3 && item !== null && item !== void 0 && item.cardStyle3) {
        cardStyle = {
          background: item.cardStyle3,
          border: 'none'
        };
      } else if ((item === null || item === void 0 ? void 0 : item.cardNumTheme) === 4 && item !== null && item !== void 0 && item.cardStyle4) {
        cardStyle = {
          background: item.cardStyle4,
          border: 'none'
        };
      }
      return _objectSpread(_objectSpread({}, item), {}, {
        cardStyle,
        href: formatUrlString(item === null || item === void 0 ? void 0 : item.href),
        key: `${index + 1}`
      });
    });
    // 筛选分页逻辑添加
    if (filterOptions) {
      //@ts-ignore
      const _filterOptions$filter = filterOptions.filterTypeList,
        filterTypeList = _filterOptions$filter === void 0 ? [] : _filterOptions$filter,
        _filterOptions$pageIn = filterOptions.pageIndex,
        pageIndex = _filterOptions$pageIn === void 0 ? 0 : _filterOptions$pageIn,
        _filterOptions$pageSi = filterOptions.pageSize,
        pageSize = _filterOptions$pageSi === void 0 ? 0 : _filterOptions$pageSi;
      console.log('异形logo+描述列表组件接手的参数', filterTypeList, pageIndex, pageSize);

      // filterTypeList过滤条件
      if ((filterTypeList === null || filterTypeList === void 0 ? void 0 : filterTypeList.length) > 0) {
        configurationFormatted = configurationFormatted.filter((o, index) => filterTypeList.includes(index) && o);
      }
      console.log('configurationFormatted::添加过滤条件之后的列表', configurationFormatted);

      // 展示当前页 [1,2,3,4,5,6] pageSize: 2, pageIndex: 1  [1,2]   pageSize: 2, pageIndex: 2 [3,4]
      if (pageIndex && pageSize) {
        configurationFormatted = configurationFormatted.filter((o, index) => {
          if (index >= (pageIndex - 1) * pageSize && index < pageIndex * pageSize) {
            return o;
          }
        });
      }
    }
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色
    const _formatVodData = (0, _formatVodData2.formatVodData)(backgroundImage),
      url = _formatVodData.url;
    if (url) {
      bgStyle['backgroundImage'] = `url(${url})`;
      bgStyle['backgroundSize'] = 'cover';
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle,
      className: "gem-pic-text"
    }, (0, _reportUtil.reportShow)(['show_picText', componentKey, modTitle])), /*#__PURE__*/React.createElement(CustomerDescription, {
      flexTitle: modTitle,
      desc: desc,
      configuration: configurationFormatted,
      style: bgStyle,
      lightTheme: lightTheme,
      filterOptions: filterOptions || {}
    }));
  }
  return /*#__PURE__*/React.createElement("div", null);
}